import COS, { ProgressInfo } from 'cos-js-sdk-v5';
import { isWOA } from '@/infrastructure/auth';
import { logger } from '@/infrastructure/logger';

interface ISecret {
  region?: string | null;
  bucket?: string | null;
  secretId?: string | null;
  secretKey?: string | null;
  sessionToken?: string | null;
  expiredTime?: number | null;
  startTime?: number | null;
}
/**
 * 上传文件到后台 COS
 */
export const uploadFileToCos = async (param: {
  file: File,
  secret?: ISecret;
  key: string;
  contentType?: string;
  onProgress?: (params: { percent: number }) => void,
}): Promise<COS.UploadFileResult | null> => {
  try {
    const { file, secret, key, contentType, onProgress } = param;
    const { bucket, secretId, secretKey, sessionToken, expiredTime, region } = secret || {};
    const domain = isWOA() ? `${bucket}.cos-internal.${region}.tencentcos.cn` : `${bucket}.cos.${region}.myqcloud.com`;
    // 外网使用${bucket}.cos.${region}.myqcloud.com
    const cos = new COS({
      Domain: domain,
      ServiceDomain: 'service.cos.tencentcos.cn',
      async getAuthorization(_options, callback) {
        callback({
          TmpSecretId: secretId || '',
          TmpSecretKey: secretKey || '',
          SecurityToken: sessionToken || '',
          StartTime: 0,
          ExpiredTime: expiredTime || 0,
        });
      },
    });
    return await cos.uploadFile({
      Bucket: bucket || '',
      Region: region || '',
      Key: key,
      Body: file,
      ContentType: contentType,
      SliceSize: 1024 * 1024 * 5,
      ChunkSize: 1024 * 1024,
      onProgress: (params: ProgressInfo) => {
        onProgress?.({
          percent: params.percent * 100,
        });
      },
    });
  } catch (e) {
    logger.error('uploadFile|error', e);
    return null;
  }
};
